<template>
  <div>
    <div class="hs1">
      <img src="../../../assets/img/pagess/mobile/sky101/1.png" alt="" />
    </div>
    <div class="h2">
      <img src="../../../assets/img/pagess/mobile/sky101/2.png" alt="" />
    </div>
    <div class="h3">
      <img src="../../../assets/img/pagess/mobile/sky101/3.png" alt="" />
      <img class="btn" @click="to_xiazai()" src="../../../assets/img/pagess/mobile/sky101/btns.gif" alt="" />
    </div>
    <div class="h4">
      <img src="../../../assets/img/pagess/mobile/sky101/4.png" alt="" />
    </div>
    <div class="h5">
      <img src="../../../assets/img/pagess/mobile/sky101/5.png" alt="" />
      <img class="btn" @click="to_xiazai()" src="../../../assets/img/pagess/mobile/sky101/btns.gif" alt="" />
    </div>
    <div class="h6">
      <img src="../../../assets/img/pagess/mobile/sky101/6.png" alt="" />
    </div>
    <div class="h7">
      <img src="../../../assets/img/pagess/mobile/sky101/7.png" alt="" />
      <img class="btn" @click="to_xiazai()" src="../../../assets/img/pagess/mobile/sky101/btns.gif" alt="" />
    </div>
    <div class="h8">
      <img src="../../../assets/img/pagess/mobile/sky101/8.png" alt="" />
    </div>
    <div class="h9">
      <img src="../../../assets/img/pagess/mobile/sky101/9.png" alt="" />
      <img class="btn" @click="to_xiazai()" src="../../../assets/img/pagess/mobile/sky101/btns.gif" alt="" />
    </div>
    <div class="h10">
      <img src="../../../assets/img/pagess/mobile/sky101/10.png" alt="" />
    </div>
    <div class="h11">
      <!-- <img class="img1" src="../../../assets/img/pagess/mobile/sky101/heng.png" alt=""> -->
      <div class="img2">
        <img src="../../../assets/img/pagess/mobile/sky101/btn.gif" alt="" />
      </div>
    </div>
    <div class="tan" v-if="tan">
      <div class="li-1">
        <span>姓名:</span>
        <el-input v-model="form.name" style="width: 2rem" placeholder="请输入您的姓名"></el-input>
      </div>
      <div class="li-1">
        <span>电话:</span>
        <el-input v-model="form.phone" style="width: 2rem" placeholder="请输入您的电话号码"></el-input>
      </div>
      <div class="li-2">
        <el-button style="
            width: 3rem;
            height: 0.8rem;
            font-size: 0.16rem;
            text-align: center;
          " size="medium" type="primary" @click="push_xinxi()">立即提交</el-button>
      </div>
      <div class="aa">
        <img @click="close()" class="close" src="../../../assets/img/pagess/mobile/sky101/close.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tan: false,
      form: {
        name: "",
        phone: "",
      }
    };
  },
  mounted() {
    this.clientIp();
  },
  methods: {
    clientIp() {
      this.$http
        .post("/client_ip", { url: window.location.href })
        .then((res) => {
          window.localStorage.setItem("_number", res.data);
        });
    },
    to_xiazai() {
      this.tan = true;
    },
    close() {
      this.tan = false;
    },
    push_xinxi() {
      this.$http
        .post("/creates-info", {
          phone: this.form.phone,
          name: this.form.name,
        })
        .then((res) => { });
    },
  },
};
</script>
<style lang="less" scoped>
.tan {
  position: fixed;
  top: 2rem;
  left: 1.25rem;
  width: 5rem;
  height: 3.5rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .aa {
    width: 0.1rem;
    margin: 0 auto;
    position: absolute;

    .close {
      position: relative;
      width: 0.4rem;
      height: 0.4rem;
      left: 2.1rem;
      top: 0.1rem;
    }
  }

  .li-1 {
    padding-top: 0.2rem;
    display: flex;
    align-items: center;

    span {
      font-size: 0.16rem;
    }
  }

  .li-2 {
    margin-top: 0.2rem;
    font-size: 0.16rem;
  }
}

* {
  font-size: 0;
}

img {
  width: 100%;
  height: 100%;
}

.hs1 {
  width: 100%;
  height: 4.68rem;
}

.h2 {
  width: 100%;
  height: 4.68rem;
}

.h3 {
  width: 100%;
  height: 4.68rem;
  position: relative;

  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    top: 0;
    left: 0.8rem;
  }
}

.h4 {
  width: 100%;
  height: 4.68rem;
}

.h5 {
  width: 100%;
  height: 4.68rem;
  position: relative;

  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    top: 0.9rem;
    left: 0.8rem;
  }
}

.h6 {
  width: 100%;
  height: 4.68rem;
}

.h7 {
  width: 100%;
  height: 4.68rem;
  position: relative;

  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    top: 1.3rem;
    left: 0.8rem;
  }
}

.h8 {
  width: 100%;
  height: 4.68rem;
}

.h9 {
  width: 100%;
  height: 4.68rem;
  position: relative;

  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    bottom: 1rem;
    left: 0.8rem;
  }
}

.h10 {
  width: 100%;
  height: 4.68rem;
}

.h11 {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.62rem;
  background: url(../../../assets/img/pagess/mobile/sky101/heng.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-end;

  .img2 {
    padding-top: 0.19rem;
    padding-right: 0.12rem;
    width: 2.61rem;
    height: 0.78rem;
  }
}
</style> 


// WEBPACK FOOTER //
// src/pages/pagess/mobile/gdd101.vue